import React from 'react';
import { chapterColor, termGradient } from './planningColors';

const Bar = ({ percent, gradient }) => (
  <div className="h-2.5 rounded-full bg-slate-100 overflow-hidden"><div className={`h-full rounded-full bg-gradient-to-r ${gradient} transition-all`} style={{ width: `${percent}%` }} /></div>
);

const Row = ({ label, b, gradient, dot }) => (
  <div className="space-y-1" data-testid={`progress-row-${label.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}`}>
    <div className="flex items-center justify-between text-sm">
      <span className="text-slate-800 font-medium truncate pr-3 inline-flex items-center gap-2">{dot && <span className={`h-2.5 w-2.5 rounded-full ${dot}`} />}{label}</span>
      <span className="text-slate-500 text-xs shrink-0">{b.taught}/{b.planned} taught · {b.carried_over} carried · <span className="font-semibold text-emerald-700">{b.percent}%</span></span>
    </div>
    <Bar percent={b.percent} gradient={gradient} />
  </div>
);

export const PlannerProgress = ({ progress }) => (
  <div className="space-y-6" data-testid="planner-progress">
    <div className="rounded-xl border bg-white p-5">
      <p className="text-xs uppercase tracking-wide text-slate-400 mb-2">Whole year</p>
      <div className="flex items-end gap-4">
        <span className="text-4xl font-bold text-emerald-700" data-testid="progress-overall-percent">{progress.overall.percent}%</span>
        <span className="text-sm text-slate-500 pb-1">{progress.overall.taught} of {progress.overall.planned} lessons taught · {progress.overall.carried_over} carried over · {progress.overall.not_yet} not yet</span>
      </div>
      <div className="mt-3"><Bar percent={progress.overall.percent} gradient="from-sky-500 via-indigo-500 to-violet-500" /></div>
    </div>
    <div className="grid gap-6 md:grid-cols-2">
      <div className="rounded-xl border bg-white p-5 space-y-4">
        <h3 className="font-semibold text-slate-800">By term</h3>
        {progress.by_term.map((t) => <Row key={t.term} label={t.term} b={t} gradient={termGradient(t.term)} />)}
      </div>
      <div className="rounded-xl border bg-white p-5 space-y-4">
        <h3 className="font-semibold text-slate-800">By chapter</h3>
        {progress.by_chapter.map((c) => <Row key={c.chapter} label={c.chapter} b={c} gradient={chapterColor(c.chapter).bar} dot={chapterColor(c.chapter).dot} />)}
      </div>
    </div>
  </div>
);
